module.exports = __webpack_public_path__ + "img/1.9bbe919b.jpg";